<template>
    <div id="modal-apply-tech-set" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="mb-2">
                        <span> 提案用情報 ({{techPubLen}}/2000) </span>
                        <span class="btn btn-link py-0" @click="makeTechPub">作成</span>
                    </div>
                    <div class="mb-2">
                        <textarea ref="techPub" v-model.trim="techPub" :style="techPubStyle" 
                                class="form-control" maxlength="2000" spellcheck=false></textarea>
                    </div>

                    <!-- 履歴書 Pdf upload -->
                    <file-upload ref="techPdf" lab="履歴書PDF" :ext="['pdf']" :required="false" :size="2"></file-upload>

                    <div class="text-muted mt-2">
                        <input type="checkbox" v-model="saveFlg">
                        履歴書テーブルに同期します
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger" type="button" @click="saveTechPub" :disabled="!techPub">
                        保存する
                    </button>
                    <button class="btn btn-success" type="button" @click="hideThis">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from 'pages/commons/form/File'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            FileUpload
        },
        data () {
            return {
                item: {},
                name: '',
                applyId: '',
                techPub: '',
                techPubHeight: '100px',
                saveFlg: true
            }
        },
        mounted () {
            $('#modal-apply-tech-set').on('shown.bs.modal', () => {
                this.name = this.item.name
                this.applyId = this.item.apply_id
                this.techPub = this.item.tech_info_pub ? this.item.tech_info_pub : ''
            })
        },
        watch: {
            techPub () {
                this.resize()
            },
            getSaveApplyTechStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startSpinner')
                }
                if (status == '2') {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == '3') {
                    this.$store.dispatch('startSpinner')
                }
            }
        },
        computed: {
            techPubLen () {
                return this.techPub.length
            },
            techPubStyle () {
                return {
                    "height": this.techPubHeight,
                    "min-height": "100px"
                }
            },
            ...mapGetters(['getSaveApplyTechStatus'])
        },
        methods: {
            saveTechPub () {
                let formData = this.makeFormData()
                this.$store.dispatch('saveApplyTech', formData)
            },
            makeFormData (form) {
                let formData = new FormData();
                // 履歴書名
                formData.append('name', this.name)
                formData.append('applyId', this.applyId)
                formData.append('techPub', this.techPub)
                // 共通commonServiceのメソッドに合わせfile_pdfをkeyにする
                formData.append('file_pdf', this.$refs.techPdf.getFile())
                formData.append('saveFlg', this.saveFlg)
                return formData
            },
            resize () {
                this.techPubHeight = "auto"
                this.$nextTick(()=> {
                    this.techPubHeight = this.$refs.techPub.scrollHeight + 20 + "px"
                })
            },
            makeTechPub () {
                this.techPub = this.$parent.makeTechPub()
            },
            openThis (item) {
                this.item = item
                $('#modal-apply-tech-set').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-apply-tech-set').modal('hide')
            },
            resetThis () {
                this.name = ''
                this.applyId = ''
                this.techPub = ''
                this.techPubHeight = "100px"
                this.saveFlg = true
                this.$refs.techPdf.resetThis()
            },
        }
    }
</script>

<style>

</style>
